import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitAttentionGrouping = createSelector(
  selectFinancialCockpitState,
  ({ attentionGrouping }) => attentionGrouping
)
